<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card class="risk-assessment scroll-form" height="100%">
        <v-card-title
          class="headline indigo darken-4 white--text fixed-header"
          primary-title
        >
          {{
            $vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()
          }}
        </v-card-title>

        <v-layout row wrap>
          <PowraTitle
            :avatar="'A'"
            :title="$vuetify.t('$vuetify.powra.siteAndTaskDetails')"
          />

          <v-flex xs4 class="blue-grey lighten-5">
            <v-card-text class="font-weight-bold no-bottom-border">
              {{ $vuetify.t('$vuetify.powra.jobNo') }}
            </v-card-text>
          </v-flex>

          <v-flex xs8 class="blue-grey lighten-5">
            <v-card-text class="no-bottom-border">
              {{ callDetail.call_remote_id }}
            </v-card-text>
          </v-flex>

          <v-flex xs4 class="blue-grey lighten-5">
            <v-card-text class="font-weight-bold no-bottom-border">
              {{ $vuetify.t('$vuetify.powra.client') }}
            </v-card-text>
          </v-flex>

          <v-flex xs8 class="blue-grey lighten-5">
            <v-card-text class="no-bottom-border">
              {{ callDetail.company }}
            </v-card-text>
          </v-flex>

          <v-flex xs4 class="blue-grey lighten-5">
            <v-card-text class="font-weight-bold no-bottom-border">
              {{ $vuetify.t('$vuetify.powra.siteAddress') }}
            </v-card-text>
          </v-flex>

          <v-flex xs8 class="blue-grey lighten-5">
            <v-card-text class="no-bottom-border">
              <span v-if="callDetail.address_line_1">{{
                callDetail.address_line_1
              }}</span>
              <span v-if="callDetail.address_line_2"
                >, {{ callDetail.address_line_2 }}</span
              >
              <span v-if="callDetail.address_line_3"
                >, {{ callDetail.address_line_3 }}</span
              >
              &nbsp;
            </v-card-text>
          </v-flex>

          <v-flex xs12 class="border">
            <v-card-text>
              <v-textarea
                outline
                v-model="taskDetails"
                :label="$vuetify.t('$vuetify.powra.taskDetails')"
                auto-grow
              ></v-textarea>
            </v-card-text>
          </v-flex>
        </v-layout>

        <div class="footer text-xs-center mb-3">
          <v-divider></v-divider>
          <v-card-text>
            <v-btn @click="back()">
              {{ $vuetify.t('$vuetify.calls.back') }}
            </v-btn>

            <v-btn color="success" @click="confirm()">
              {{ $vuetify.t('$vuetify.calls.proceedToTheNextSection') }}
            </v-btn>
            <abort-visit v-on:aborted="visitAborted()" />
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AbortVisit from '@/components/AbortVisit.vue'
import PowraTitle from '@/components/powra/PowraTitle.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  props: ['show', 'call'],
  components: {
    AbortVisit,
    PowraTitle
  },
  data() {
    return {
      dialog: false,
      taskDetails: ''
    }
  },
  mounted() {
    if (this.call) {
      this.taskDetails = this.call.description
    }
  },
  computed: {
    ...mapState({
      // currentRiskAssessment: state => state.calls.currentRiskAssessment,
    }),
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall',
      hasPowra: 'calls/hasPowra',
      currentRiskAssessment: 'calls/currentRiskAssessment'
    }),
    callDetail() {
      return this.getActiveCall
    }
  },
  methods: {
    confirm() {
      this.dialog = false
      this.$emit('confirmed', { task_details: this.taskDetails })
    },
    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },
    back() {
      this.dialog = false
      this.$emit('back')
    },
    populateActivePowraValues() {
      this.taskDetails = this.currentRiskAssessment.task_details
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    },
    callDetail(val) {
      this.taskDetails = val.description
    },
    hasPowra: function() {
      if (this.hasPowra) {
        this.populateActivePowraValues()
      }
    }
  }
}
</script>

<style scoped>
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}

.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
</style>
